import { ElementType } from 'react';
import { ImageTagging } from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/components/common';
import { ImageSelectDesktop } from './components';

type Step = {
  label: string;
  component: ElementType<{ onComplete: () => void; layout: 'mobile' | 'desktop'; loading?: boolean }>;
};

export const DESKTOP_STEPS: Step[] = [
  {
    label: 'uploadImageTitle',
    component: ImageSelectDesktop,
  },
  {
    label: 'uploadImageTaggingTitle',
    component: ImageTagging,
  },
];
